import React from 'react';
import { Card } from 'semantic-ui-react';
import css from './ServicesCardPlaceholder.scss';
import cardCss from './ServicesCard.scss';
import cardHeaderCss from './ServicesCardHeader.scss';

export default class ServicesCardPlaceholder extends React.Component {
	render() {
		return (
			<div className={cardCss["services-card"]}>
				<Card fluid>
					<Card.Header className={css['top-bar']} />
					<Card.Header className={cardHeaderCss['card-header-container']}>
						<div className={`${cardHeaderCss["card-header-image"]} ${css["placeholder-avatar"]}`} />
					</Card.Header>
					<Card.Content>
						<Card.Header><p className={css['placeholder-title']}>&nbsp;</p></Card.Header>
						<Card.Description className={css['lines-container']}>
							<p>&nbsp;</p>
							<p>&nbsp;</p>
							<p>&nbsp;</p>
							<p>&nbsp;</p>
						</Card.Description>
					</Card.Content>
				</Card>
			</div>
		);
	}
}
